import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageAuthService } from '../services/storage-auth/storage-auth.service';
import { NavigationPipe } from '../pipes/navigation/navigation.pipe';
import { ToasterService } from '@mars/ui-components';
import { TranslocoService } from '@jsverse/transloco';
import { Path } from '../constants/paths.constant';

/**
 * Guard to protect OTP route
 * Ensures OTP_ID and USER_EMAIL exist in storage before allowing access
 */
export const otpStorageGuard: CanActivateFn = () => {
  const storageAuthService = inject(StorageAuthService);
  const router = inject(Router);
  const toastrService = inject(ToasterService);
  const translocoService = inject(TranslocoService);
  const navigationPipe = new NavigationPipe();

  const otpId = storageAuthService.getOtpId();
  const userEmail = storageAuthService.AuthUserData()?.email ?? '';

  if (!otpId || !userEmail) {
    toastrService.warning(translocoService.translate('auth_session_expired'));
    router.navigate(['/' + navigationPipe.transform(Path.SIGN_UP)]);
    return false;
  }

  return true;
};
